import { render, staticRenderFns } from "./CultureQuestion.vue?vue&type=template&id=edb30538"
import script from "./CultureQuestion.vue?vue&type=script&lang=js"
export * from "./CultureQuestion.vue?vue&type=script&lang=js"
import style0 from "./CultureQuestion.vue?vue&type=style&index=0&id=edb30538&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports